import { render, staticRenderFns } from "./RealVehicleList.vue?vue&type=template&id=531cdf6e&scoped=true&"
import script from "./RealVehicleList.vue?vue&type=script&lang=js&"
export * from "./RealVehicleList.vue?vue&type=script&lang=js&"
import style0 from "./RealVehicleList.vue?vue&type=style&index=0&id=531cdf6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531cdf6e",
  null
  
)

export default component.exports